module.exports = __webpack_public_path__ + "1cc2d16a15d858c7444e96b1f761285f.jpg";